"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DraftStatus = exports.DraftAction = void 0;
let DraftAction = exports.DraftAction = /*#__PURE__*/function (DraftAction) {
  DraftAction["ADDED"] = "Added";
  DraftAction["UPDATED"] = "Updated";
  DraftAction["REMOVED"] = "Removed";
  return DraftAction;
}({});
let DraftStatus = exports.DraftStatus = /*#__PURE__*/function (DraftStatus) {
  DraftStatus["EDITING"] = "Editing";
  DraftStatus["PENDING"] = "Pending";
  DraftStatus["APPROVED"] = "Approved";
  DraftStatus["REJECTED"] = "Rejected";
  return DraftStatus;
}({});